import { Table as MuiTable, Paper, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'

import { AdminDataGridTitle } from '.'

export const createVerticalTableData = (
  header: string,
  value: string | number | undefined | null,
  onClick?: () => void,
) => {
  if (onClick) {
    return { header, value, onClick }
  }
  return { header, value }
}

type TableVerticalProps = {
  tableRows: { header: string; value: string | number | undefined | null; onClick?: () => void }[]
  title?: string
  noRowsMessage?: string
  noShadow?: boolean
  dense?: boolean
  enabled?: boolean
  action?: React.ReactNode | React.ReactNode[]
}

export const TableVertical = ({
  tableRows = [],
  title,
  noRowsMessage,
  noShadow = false,
  dense = false,
  enabled = true,
  action,
}: TableVerticalProps) => {
  return (
    <TableContainer component={Paper} sx={!noShadow ? {} : { boxShadow: 'none' }}>
      {title && <AdminDataGridTitle title={title} action={action} />}
      <MuiTable sx={{ minWidth: 200 }} aria-label="simple table" size={dense ? 'small' : 'medium'}>
        <TableBody>
          {tableRows.map((row) => (
            <TableRow
              key={row.header}
              onClick={row.onClick}
              hover={!!row.onClick}
              sx={row.onClick ? { cursor: 'pointer' } : undefined}
            >
              <TableCell component="th" scope="row">
                {row.header}
              </TableCell>
              <TableCell align="left">{row.value}</TableCell>
            </TableRow>
          ))}
          {tableRows.length === 0 && enabled && (
            <TableRow>
              <TableCell>{noRowsMessage || 'No data to display'}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </MuiTable>
    </TableContainer>
  )
}
